import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=5291852c"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5291852c')) {
      api.createRecord('5291852c', component.options)
    } else {
      api.reload('5291852c', component.options)
    }
    module.hot.accept("./dropzone.vue?vue&type=template&id=5291852c", function () {
      api.rerender('5291852c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/dropzone.vue"
export default component.exports